module.exports = __webpack_public_path__ + "static/minimumwidth-419e5f2b69a424a6968d0eddfb922c3b.png";